module.exports = __webpack_public_path__ + "static/media/11-3.9ea2268a.mp3";